var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col h-screen"},[_c('mainHeader'),_c('div',{staticClass:"page-content pb-auto"},[_c('div',{staticClass:"wrapper"},[_c('router-view')],1)]),_c('mainFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }